import React from "react";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import CloseIcon from "@mui/icons-material/Close";
import { colors } from "../config/colors";
import { FONT_SIZE_CUSTOM_LG, FONT_WEIGHT_MEDIUM, LINE_HEIGHT_MD } from "../config/styles";

const StyledModalHeader = styled("div")({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "24px 32px",
  borderBottom: `1px solid ${colors.storkeLight}`,
  
  "& .modal-title": {
    fontSize: FONT_SIZE_CUSTOM_LG,
    fontWeight: FONT_WEIGHT_MEDIUM,
    lineHeight: LINE_HEIGHT_MD,
    color: colors.custom,
    margin: 0,
    fontFamily: "DM Sans",
  },
  
  "& .close-button": {
    background: "none",
    border: "none",
    cursor: "pointer",
    padding: "8px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: colors.nonActive,
    transition: "color 0.2s ease",
    
    "&:hover": {
      color: colors.custom,
    },
    
    "& svg": {
      fontSize: "24px",
    },
  },
});

/**
 * ModalHeader Component
 * 
 * Reusable modal header with title and close button.
 * Provides consistent styling across all modal dialogs.
 * 
 * @param {string} title - The modal title text
 * @param {function} onClose - Handler for close button click
 */
export const ModalHeader = ({ title, onClose }) => {
  return (
    <StyledModalHeader>
      <h2 className="modal-title">{title}</h2>
      <button className="close-button" onClick={onClose} aria-label="Close">
        <CloseIcon />
      </button>
    </StyledModalHeader>
  );
};

ModalHeader.propTypes = {
  title: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
};